import "@/styles/globals.css";
import "@/public/assets/fonts/stylesheet.css";
import { default as AppContextProvider, useApplicationContext } from "@/context/context";
import { Theme } from '@vernost_dev/vms-react-components/dist/Theme/';
import {TabProvider } from "@/context/tabContext"

export default function App({ Component, pageProps }) {
  return (
    <Theme>
      <AppContextProvider>
        <TabProvider>
        <Component {...pageProps} />
        </TabProvider>  
        </AppContextProvider>  
    </Theme>);
}